import type { AvatarsPlacas } from '../../../modules/avatars/types/placa';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/MACRO/placas`;

/**
 * Placas de MACRO. El user elige una en Studio (SettingsPanel) o `Sin placa`.
 * La elección se persiste en el project record de DDB (`placaId`) y el editor
 * la inyecta al primer boot si `editorState` no existe todavía.
 *
 */
export const MACRO_AVATARS_PLACAS: AvatarsPlacas = {
  outros: [
    {
      id: 'azul',
      label: 'Cierre azul',
      files: {
        vertical: { videoUrl: `${BASE}/outro-azul-vertical.mp4` },
        wide: { videoUrl: `${BASE}/outro-azul-wide.mp4` }
      }
    },
    {
      id: 'blanco',
      label: 'Cierre blanco',
      files: {
        vertical: { videoUrl: `${BASE}/outro-blanco-vertical.mp4` },
        wide: { videoUrl: `${BASE}/outro-blanco-wide.mp4` }
      }
    },
    {
      id: 'slogan',
      label: 'Cierre con slogan',
      files: {
        vertical: { videoUrl: `${BASE}/outro-slogan-vertical.mp4` },
        wide: { videoUrl: `${BASE}/outro-slogan-wide.mp4` }
      }
    },
    {
      id: 'selecta',
      label: 'Cierre Selecta',
      files: {
        vertical: { videoUrl: `${BASE}/outro-selecta-vertical.mp4` },
        wide: { videoUrl: `${BASE}/outro-selecta-wide.mp4` }
      }
    }
  ]
};
